import { render } from "./ModalHeader.vue?vue&type=template&id=596f2eac&scoped=true&ts=true"
import script from "./ModalHeader.vue?vue&type=script&lang=ts"
export * from "./ModalHeader.vue?vue&type=script&lang=ts"

import "./ModalHeader.vue?vue&type=style&index=0&id=596f2eac&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596f2eac"]])

export default __exports__